// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_lbXnI {
  position: fixed;
  inset: 0;
  z-index: 1;
}
.variableListModal_kZKP7 {
  position: absolute;
  top: 100px;
  background-color: var(--white-background);
  z-index: 3;
  min-width: 400px;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  .variablesList_QYDMX
{
    display: flex;
    flex-direction: column;

    p {
      font-weight: 500;
      padding: 10px 5px;
      color: var(--_2-color);
      &:hover {
        background-color: var(--ececf1-background);
      }
    }
  }
  p {
    font-weight: 500;
    padding: 10px 5px;
  }
  .newConcept_S6kNG {
    background-color: var(--f5-background);
    padding: 10px 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #666666;

    svg {
      width: 10px;
      height: 10px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/VariableListModal/VariableListModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C;;IAEE,aAAa;IACb,sBAAsB;;IAEtB;MACE,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;MACtB;QACE,0CAA0C;MAC5C;IACF;EACF;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;;IAEd;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n}\n.variableListModal {\n  position: absolute;\n  top: 100px;\n  background-color: var(--white-background);\n  z-index: 3;\n  min-width: 400px;\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  .variablesList\n{\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: 500;\n      padding: 10px 5px;\n      color: var(--_2-color);\n      &:hover {\n        background-color: var(--ececf1-background);\n      }\n    }\n  }\n  p {\n    font-weight: 500;\n    padding: 10px 5px;\n  }\n  .newConcept {\n    background-color: var(--f5-background);\n    padding: 10px 30px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #666666;\n\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_lbXnI`,
	"variableListModal": `variableListModal_kZKP7`,
	"variablesList": `variablesList_QYDMX`,
	"newConcept": `newConcept_S6kNG`
};
export default ___CSS_LOADER_EXPORT___;
